import { useEffect, useState } from "react";
import { getProviders, type Providers } from "../api";
import { t } from "../i18n";
import { loginUrl } from "../lib";
import { GoogleIcon, MetaIcon } from "./icons";

/**
 * "Sign in with …" buttons; an unconfigured provider is a disabled button with a hint.
 * `hero` - the landing's row next to the link; the buttons are white in both variants (owner 2026-10-14).
 */
export function LoginButtons({ returnTo, variant }: { returnTo?: string; variant?: "hero" }) {
  const [providers, setProviders] = useState<Providers | null>(null);
  useEffect(() => {
    getProviders()
      .then(setProviders)
      .catch(() => setProviders({ google: { configured: true }, meta: { configured: true } }));
  }, []);

  const items = [
    { key: "google", name: "Google", Icon: GoogleIcon },
    { key: "meta", name: "Meta", Icon: MetaIcon },
  ] as const;

  return (
    <div className={`actions login-row${variant === "hero" ? " login-hero" : ""}`}>
      {items.map(({ key, name, Icon }) => {
        const ok = providers ? providers[key].configured : true;
        return (
          <div key={key}>
            {ok ? (
              <a className={"btn login"} href={loginUrl(key, returnTo)}>
                <Icon />
                {t("login.with", { provider: name })}
              </a>
            ) : (
              <span className={"btn login"} aria-disabled="true">
                <Icon />
                {t("login.with", { provider: name })}
              </span>
            )}
            {!ok && <div className="hint">{t("conn.notConfigured")}</div>}
          </div>
        );
      })}
    </div>
  );
}
